import { format } from 'date-fns';

export const timeToTimestampFormatter = (time: string, date?: Date) => new Date(Date.parse(`${format(date || new Date(), 'MM/dd/yyyy')} ${time}`)) || undefined;
